import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaPhoneAlt, FaFacebook, FaInstagram, FaEnvelope, FaLinkedin } from 'react-icons/fa';
import { MdLocationOn } from 'react-icons/md'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import emailjs from 'emailjs-com'; // Importando a biblioteca do EmailJS
import logo from '../../img/logo.png'; // Importe o logo da empresa
import './Contacto.css'

const Contacto = () => {
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showPopup, setShowPopup] = useState(false); // Estado para controlar o popup

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Usando EmailJS para enviar o e-mail
    emailjs
      .sendForm(
        'service_f9id7w7', // Substitua pelo seu ID do serviço
        'template_ou8vf3d', // Substitua pelo seu ID de template
        e.target, // O formulário que será enviado
        'J-0gTEIsBL4xg9ra6' // Substitua pelo seu ID de usuário do EmailJS
      )
      .then(
        (result) => {
          console.log('Email enviado com sucesso!', result.text);
          setIsSubmitted(true); // Marcar como enviado
          setShowPopup(true); // Exibir o popup de sucesso
          setTimeout(() => setShowPopup(false), 3000); // Esconder popup após 3 segundos
        },
        (error) => {
          console.error('Erro ao enviar o e-mail:', error.text);
        }
      );

    // Limpar o formulário após o envio
    setFormData({
      name: '',
      email: '',
      message: '',
    });
  };
  const [showAlert, setShowAlert] = useState(false);
  // Show the alert after 2 minutes (120000ms)
    useEffect(() => {
      const timer = setInterval(() => {
        setShowAlert(true); // Show the alert after 2 minutes
      }, 20000);
  
      return () => clearTimeout(timer); // Clean up the timer when the component is unmounted
    }, []);
    useEffect(() => {
      const timer = setTimeout(() => {
        setShowAlert(true); // Show the alert after 2 minutes
      }, 9);
  
      return () => clearTimeout(timer); // Clean up the timer when the component is unmounted
    }, []);

  return (
    <section style={{ marginBottom: '70px', marginTop: "70px" }}>
      <Container>
        <Row>
          {/* Primeira coluna: Endereço */}
          <Col md={6} className="d-flex justify-content-center">
            <div className="text-center" style={{ paddingTop: '50px' }}>
              <h2 className="text-center" style={{ position: 'relative', fontSize: '46px', display: 'inline-block' }}>
                <b>Fale connosco</b>
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: '0',
                  width: '50%', 
                  height: '2px',
                  backgroundColor: '#ff5722'
                }} />
              </h2>
              <Row className="d-flex align-items-center justify-content-between" style={{ marginBottom: '15px', marginTop: '45px' }}>
                <Col xs="auto">
                  <MdLocationOn style={{ color: '#ff5722', fontSize: '15px' }} />
                </Col>
               
                <Col>
                  <div style={{ width: '12.5rem', textAlign: 'left' }}>
                  Centralidade do Kilamba
                    <br />
                    Quarteirão F, edifício F27
                    <br />
                    apartamento 91
                  </div>
                </Col>
              </Row>

              <div style={{ marginRight: '160px' }}>
                <p style={{ marginRight: '40px' }}>
                  <a
                    href="tel:+244972614886"
                    style={{ textDecoration: 'none', color: 'black',whiteSpace: 'nowrap' }}
                  >
                    <FaPhoneAlt style={{ color: '#ff5722', fontSize: '15px', marginRight: '15px' }} />
                    +244 972 614 886
                  </a>
                </p>
                <p>
                  <a
                    href="mailto:geral@nwayami.com"
                    style={{ textDecoration: 'none', color: 'black' }}
                  >
                    <FaEnvelope style={{ color: '#ff5722', fontSize: '15px', marginRight: '15px' }} />
                    geral@nwayami.com
                  </a>
                </p>
                <span>
                  <a href="https://www.facebook.com/profile.php?id=61568662172580" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#fff', marginRight: '10px' }}>
                    <FaFacebook color="#ff5722" />
                  </a>
                  <a href="https://www.instagram.com/n.wayami/profilecard/?igsh=MWM1Mmc1aDN2ZWJkeA%3D%3D" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#fff', marginRight: '10px' }}>
                    <FaInstagram color="#ff5722" />
                  </a>
                  <a href="https://www.linkedin.com/company/n-wayami/?viewAsMember=true" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#fff' }}>
                    <FaLinkedin color="#ff5722" />
                  </a>
                </span>
              </div>
            </div>
          </Col>

          {/* Segunda coluna: Formulário de Contato */}
          <Col md={6}>
            <Form onSubmit={handleSubmit} style={{ paddingTop: '99px' }}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Control
                  type="text"
                  required
                  placeholder="Digite seu nome"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Control
                required
                  type="email"
                  placeholder="Digite seu e-mail"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formMessage">
                <Form.Control
                  as="textarea"
                  required
                  rows={3}
                  placeholder="Digite sua mensagem"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </Form.Group>
              <Button 
                style={{ backgroundColor: '#FF5722', borderColor: '#FF5722', width: '109px', padding: '10px' }} 
                type="submit" // Garantir que o botão é do tipo submit
              >
                Enviar
              </Button>
            </Form>
          </Col>
        </Row>

        {/* Mapa de Localização */}
        <Row style={{ marginTop: '50px' }}>
          <Col md={12}>
            <h3 className="text-center" style={{ marginBottom: '20px' }}>Como Chegar</h3>
            <div style={{ height: '400px', overflow: 'hidden' }}>
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.7343150461024!2d13.258668575018488!3d-8.996577191063471!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1a521feccbfcdc5b%3A0x39338cb33ba2f1ea!2sN.Wayami!5e0!3m2!1spt-PT!2sao!4v1733403154320!5m2!1spt-PT!2sao" 
                allowFullScreen
              />
            </div>
          </Col>
        </Row>
      </Container>

      {/* Popup de Sucesso */}
      {showPopup && (
        <div className="popup" style={{ backgroundColor: '#ff5722', position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ textAlign: 'center', color: 'white', padding: '20px', borderRadius: '10px' }}>
            <img src={logo} alt="Logo" style={{ width: '100px', height: '100px', marginBottom: '20px', backgroundColor:"#fff", borderRadius:"50%" }} />
            <h3>Email enviado com sucesso!</h3>
          </div>
        </div>
      )}
   
    </section>
  );
};

export default Contacto;